const SET_SESSION_STATUS = 'SET_SESSION_STATUS';
const SET_SESSION_CONFIG = 'SET_SESSION_CONFIG';
const SET_SOCKET = 'SET_SOCKET';
export default {
  SET_SESSION_STATUS,
  SET_SESSION_CONFIG,
  SET_SOCKET
}